<template>
    <div class="container-fluid mt-4">
        <div class="container-fluid">
              <div class="row d-flex justify-content-between">
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100px"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50px"/></span><br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
                <div class="col-5">
                    <img class="img-rounded" src="@/assets/images/insurancelogo1.png" height="50px" /><br>

                    <table  class="table" density="compact" style="color:black">
                    <tr class="text-uppercase"><td> Name </td><td> {{ insurances.name }}</td></tr>
                    <tr><td>Email </td><td> {{ insurances.email }} </td></tr>
                    <tr><td> Telephone </td><td> 0{{ insurances.contact }} </td></tr>
                    <tr><td> Address </td><td> {{ insurances.address }} </td></tr>
                  </table>
                </div>
              </div>
              </div>
          <h4 class="mt-2 text-center text-decoration-underline">PAYMENT`s LEDGER</h4>
              
            <div class="container-fluid">
            <h4 class="mt-3" style="color:black"> Details</h4>
              
                <span v-if="ledger.length">
                      <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead><tr><th> ID</th><th> Name</th><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                      <tbody>
                        <tr v-for="item in ledger" :key="item.id">
                            <td>{{ item.patient_id }} </td>
                            <td>{{ item.patient_name }} </td>
                            <td>{{ item.service_category.name }} </td>
                            <td>{{ item.service_name.name }}</td>
                            <td>{{ commas (item.price) }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </span>
          
              <div class="d-flex justify-content-between">
                      <span class="h5 text-black"> Total Amount: <span class="text-primary h2">{{ commas(totalServicePrice) }}</span></span>
                      
                    </div>
            </div>
            <div class="mt-3 text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
                <br> Printed Via Afrimed Software
                <br> www.afrimed.com </p>
            </div>
        </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      insurances:[],
      ledger:[],
      ledgers:[],
      
    };
  },
  created() {
    this.showcompany();

    this.fetchInfo();
  },
  // computed:{
  //   totalServicePrice() {
      
  //     return this.ledger.reduce((total, item) => total + item.price, 0);
  //   },
  //   totalPresciptionsPrice() {
      
  //     return this.prescriptions.reduce((total, prescription) => total + prescription.totalprice, 0);
  //   },
   
   
  //   totalAmountPrice(){
  //     return this.totalServicePrice
  //   },
  
  // },
  computed: {
  totalServicePrice() {
    return this.ledger.reduce((total, item) => total + Number(item.price || 0), 0);
  },
  totalPresciptionsPrice() {
    return this.prescriptions.reduce((total, prescription) => total + Number(prescription.totalprice || 0), 0);
  },
  totalAmountPrice() {
    return this.totalServicePrice + this.totalPresciptionsPrice;
  }
},
  methods: {
    commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/insuranceledgers/${this.id}`;
      await axios.get(url).then((response) => {
        this.ledger = response.data.ledgers;
        this.companyId = response.data.ledgers[0].company.id;
        this.showcompany();
        
      });
    },
    async showcompany(){
    
      this.companyid = this.$route.query.id;
      let url = `/insurancecompanyprofile/${this.companyid}`;

      await axios.get(url).then((response) => {
        this.insurances = response.data.insurancecompany;
        this.insurancespinner=false;
      });
    },
  },
  mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5800);
},
};
</script>